import { useMutation, useQuery } from "@tanstack/react-query";
import { Card, Form, Input, message } from "antd";
import { businessAreaService } from "../../../services/business-area.service";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";

export default function BusinessAreaForm(){

  const [form] = Form.useForm()

  const navigate = useNavigate()

  const { id } = useParams()

  const { data: businessArea  } = useQuery({
    queryKey: ['detailBusinessArea', id],
    queryFn: () => businessAreaService.getById(id),
    enabled: !!id
  })

  useEffect(() => {
    if(id){
      form.setFieldsValue(businessArea?.data)
    }
  }, [businessArea, form, id])

  const storeMutation = useMutation({
    mutationFn: val => businessAreaService.store(val),
    onSuccess: () => {
      message.success("Data Berhasil dibuat")
      navigate('/master-data/business-area') 
    },
    onError: (err) => {
      message.error("Terjadi Kesalahan")
      console.log(err)
    }
  })

  const updateMutation = useMutation({
    mutationFn: val => businessAreaService.update(val),
    onSuccess: () => {
      message.success("Data Berhasil diubah")
      navigate('/master-data/business-area') 
    },
    onError: (err) => {
      message.error("Terjadi Kesalahan")
      console.log(err)
    }
  })

  const handleSubmit = val => {
    if(id) updateMutation.mutate(val)
    else storeMutation.mutate(val)
  }

  return (
    <>
      <Card
        title="Tambah Area Bisniss"
        actions={[
          <CardFooterAction
            key={1}
            onClick={() => form.submit()}
            route={'/master-data/business-area'}
          />
        ]}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item hidden name={'id'} >
            <Input  />
          </Form.Item>
          <Form.Item
            label="Nama Area Bisnis"
            name={'name'}
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input/>
          </Form.Item>
          <Form.Item
            label="Nama Jalan"
            name={'address'}
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input/>
          </Form.Item>
        </Form>
      </Card>
    </>   
  )
}